import NoWrapTableCell from 'Components/NoWrapTableCell'
import StyledLink from 'Components/StyledLink'
import StyledTableRow from 'Components/StyledTableRow'
import {
  type AuthorityShape,
  CampaignType,
  type SingleCodeCampaignShape
} from 'Services/SalesManagement/Features/Campaign/campaignSlice'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import type { FC } from 'react'

const getAuthoritiesAsString = (authorities: AuthorityShape[]) => {
  if (authorities.length > 0) {
    return authorities.map(authority => authority[1]).join(', ')
  }
  return '-'
}

const SingleCodeCampaignListRow: FC<{
  row: SingleCodeCampaignShape
}> = ({ row }) => {
  return (
    <StyledTableRow hover>
      <NoWrapTableCell title={datetimeFormatter(row.created)} component="th" scope="row">
        <StyledLink
          to={`${SALES_MANAGEMENT_ROOT_URL}/campaigns/${CampaignType.singleCode}/${row.id}/`}
        >
          {datetimeFormatter(row.created)}
        </StyledLink>
      </NoWrapTableCell>
      <NoWrapTableCell title={showValueOrHyphen(row.name)}>
        {showValueOrHyphen(row.name)}
      </NoWrapTableCell>
      <NoWrapTableCell title={datetimeFormatter(row.start_date)}>
        {datetimeFormatter(row.start_date)}
      </NoWrapTableCell>
      <NoWrapTableCell title={datetimeFormatter(row.end_date)}>
        {datetimeFormatter(row.end_date)}
      </NoWrapTableCell>
      <NoWrapTableCell title={getAuthoritiesAsString(row.authorities)}>
        {getAuthoritiesAsString(row.authorities)}
      </NoWrapTableCell>
      <NoWrapTableCell title={showValueOrHyphen(row.discount_code)}>
        {showValueOrHyphen(row.discount_code)}
      </NoWrapTableCell>
    </StyledTableRow>
  )
}

export { SingleCodeCampaignListRow }
